import { HelmetProvider } from "react-helmet-async";

import { useProject } from "./hooks/useProject";
import { useLeadForm } from "./hooks/useLeadForm";

import SEOHelmet from "./components/SEOHelmet";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import AboutSection from "./components/AboutSection";
import LocationSection from "./components/LocationSection";
import ApartmentSection from "./components/ApartmentSection";
import AmenitiesSection from "./components/AmenitiesSection";
import GallerySection from "./components/GallerySection";
import TowerSection from "./components/TowerSection";
import ComparisonSection from "./components/ComparisonSection";
import LoanSection from "./components/LoanSection";
import Footer from "./components/Footer";
import ContactIcons from "./components/ContactIcons";
import LeadPopup from "./components/LeadPopup";

import "./styles/global.css";

// ============================
// Loading
// ============================
function LoadingSpinner() {
  return (
    <div style={{ minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
      <p>Loading project…</p>
    </div>
  );
}

// ============================
// Error
// ============================
function ErrorScreen({ message }) {
  return (
    <div style={{ minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
      <p style={{ color: "red" }}>{message}</p>
    </div>
  );
}

// ============================
// APP
// ============================
export default function App() {
  const { data, loans, loading, error } = useProject();

  // ❗ MUST BE BEFORE RETURNS (HOOK RULE)
  const projectId = data?.projectId;

  const leadForm = useLeadForm({
    projectId,
    formDefaults: data?.formDefaults, // ✅ Backend table: project + location
  });

  // ✅ FIX: openPopup only takes one arg — the button/event label string.
  //    All child components call handleCta("Download Brochure") etc.
  //    The old `brochure` boolean second arg was unused and is removed.
  const handleCta = (event) => {
    leadForm.openPopup(event || "PopUp");
  };

  if (loading) return <LoadingSpinner />;
  if (error) return <ErrorScreen message={error} />;
  if (!data) return null;

  const {
    seo,
    header,
    about,
    location,
    apartment,
    amenities,
    gallery,
    tower,
    comparisons,
    footer,
  } = data;

  return (
    <HelmetProvider>
      <SEOHelmet seo={seo} projectId={projectId} />

      <Navbar projectId={projectId} projectName={header?.projectName} onCtaClick={handleCta} />

      <Hero projectId={projectId} header={header} onCtaClick={handleCta} />

      <AboutSection projectId={projectId} about={about} />

      <LocationSection location={location} />

      <ApartmentSection projectId={projectId} apartment={apartment} onCtaClick={handleCta} />

      <AmenitiesSection projectId={projectId} amenities={amenities} />

      <GallerySection projectId={projectId} gallery={gallery} />

      <TowerSection projectId={projectId} tower={tower} onCtaClick={handleCta} />

      <ComparisonSection comparisons={comparisons} projectName={header?.projectName} />

      <LoanSection loans={loans} projectName={header?.projectName} />

      <Footer projectId={projectId} footer={footer} />

      <ContactIcons onCtaClick={handleCta} />

      <LeadPopup leadForm={leadForm} />
    </HelmetProvider>
  );
}